<template>
  <div class="body con-wd">
    <breadcrumb :data="['项目', '创建文档', '选择模块']"></breadcrumb>
    <div class="container">
      <el-row>
        <el-col :span="6">
          <div class="left">
            <div class="cate-con">
              <div class="static scene" :style="{color: actvieSceneId === 0 ? '#E60027': '#000'}">使用场景</div>
              <div class="item" :class="[actvieSceneId === item.id && 'active']" :title="item.name" @click="handleSceneClick(item)" v-for="item in sceneList"
                :key="'scene_' + item.id">
                <svg-icon v-if="item.id === 0" iconClass="add" style="width: 14px;height: 14px;margin-left: -14px"></svg-icon>
                <span class="name">{{ item.name }}</span>
              </div>
              <div class="add">自定义场景</div>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="right">
            <el-row v-loading="loading">
              <el-col :span="12" :key="'catevos' + item.moduleId" v-for="(item, index) in moduleVosInfo">
                <div class="title">
                  {{ item.moduleName
                  }}<i @click="handlePreviewClick(index,item)" class="view"></i>
                </div>
                <div :class="['tree-con', { nosub: checkSub(item) }]">
                  <el-tree :data="item.children" show-checkbox check-on-click-node default-expand-all node-key="moduleId"
                    :ref="'tree' + index" highlight-current :props="defaultProps"
                    @check-change="handleCheckChange" :default-checked-keys="checkedlist">
                  </el-tree>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <div class="boot">
        <el-button @click="prev">上一步</el-button>
        <el-button type="primary" @click="next">下一步</el-button>
      </div>
    </div>
    <div class="drawer-con">
      <div @click="showHideDrawer" class="btn-con">
        <div v-if="drawerVisible" class="close"></div>
        <div v-else class="open"></div>
      </div>
      <div class="list-con" v-show="drawerVisible">
        <div class="title">范例预览</div>
        <div class="img-con">
          <div :key="item.id" v-for="(item,index) in imgList" class="image-wrap">
            <el-image  :src="item.src" :preview-src-list="[item.src]"/>
            <div class="no">
              <div class="val">{{ index + 1 }}</div>
            </div>
          </div>
          <div v-if="imgList.length === 0" :style="{ textAlign: 'center' }">暂无数据</div>
        </div>
      </div>
      <div v-show="!drawerVisible" style="width: 10px; height: 10px"></div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/pc/Breadcrumb'
import { mapMutations } from 'vuex'
export default {
  name: 'selectModule',
  components: {
    Breadcrumb,
  },
  beforeCreate() {
    document.body.setAttribute('style', 'background:#F4F4F5;')
  },
  // beforeDestroy() {
  //   document.body.setAttribute('style', 'background:#ffffff;')
  // },
  mounted() {
    this.businessOpprtunityId = this.$route.params.id
    this.changeMenuStatus({ value: 4 })
    this.getSceneList()
    const Checklist = localStorage.getItem('Checklist')
    if (Checklist) {
      this.checkedlist = JSON.parse(Checklist)
    }
  },
  data() {
    return {
      actvieSceneId: 0,
      loading: false,
      businessOpprtunityId: undefined,
      imgList: [],
      defaultProps: {
        children: 'children',
        label: 'moduleName'
      },
      drawerVisible: false,
      sceneList: [],
      currentScene: { id: 0 },
      moduleVosInfo: [],
      checkedlist: [],
      isShowCustomSc: false,
      selectDefault: 1
    }
  },
  methods: {
    ...mapMutations(['changeMenuStatus']),
    checkSub(item) {
      let hasSub = true
      item.children.forEach((sitem) => {
        if (sitem.children?.length > 0) {
          hasSub = false
        }
      })
      return hasSub
    },
    prev() {
      this.$router.go(-1)
    },
    next() {
      let modelList = []
      this.moduleVosInfo.forEach((item,index) => {
        const checkedNodes = this.$refs[`tree${index}`][0].getCheckedNodes(false,true)
        const treeModules = checkedNodes.map(item => item.moduleId)
        if (treeModules.length > 0) {
          modelList.push(treeModules.filter(item => item).join(','))
        }
      })
      localStorage.setItem(
        `moduleIdList-${this.businessOpprtunityId}`,
        JSON.stringify(modelList.filter(item => item))
      )
      this.$router.push(`/manage/selecttype/${this.businessOpprtunityId}`)
    },
    handleSceneClick(item) {
      this.selectDefault = 2
      this.actvieSceneId = item.id
      this.currentScene = item
      this.getSceneDocList()
    },
    handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        this.checkedlist.push(data.moduleId)
      }else {
        const index = this.checkedlist.findIndex(item => item === data.moduleId)
        if (index > -1) {
          this.checkedlist.splice(index,1)
        }
      }
      localStorage.setItem('Checklist', JSON.stringify(this.checkedlist))
    },
    handlePreviewClick(index,module) {
      //获取设置的节点
      const checkedNodes = this.$refs[`tree${index}`][0].getCheckedNodes()
      console.log(checkedNodes)
      if (checkedNodes.length === 0) {
        this.$message.warning(`请先选择【${module.moduleName}】类型`)
        return
      }
      let moduleIds = checkedNodes.map((item) => item.moduleId)
      this.imgList = []
      this.drawerVisible = true
      const postData = {
        pageNum: 1,
        pageSize: 1000,
        moduleIds: moduleIds
      }
      this.$request.getPreviewImgList(postData).then((res) => {
        if (res.code === 200) {
          let data = res.data.data.map((item, index) => {
            return {
              id: index + 1,
              src: item
            }
          })
          this.imgList = data
        }
      })
    },
    getSceneDocList() {
      this.loading = true
      this.$request.getSceneDocList(this.currentScene.id).then((res) => {
        if (res.code == 200) {
          console.log(res, '树数据')
          this.moduleVosInfo = res.data
          // this.sceneList = res.data
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getSceneList() {
      this.$request.getSceneList().then((res) => {
        if (res.code == 200) {
          this.sceneList = res.data.data
          // if (res.data.isShowCustomSc) {
          //   this.sceneList.push({
          //     id: 0,
          //     name: '自定义场景'
          //   })
          // }
          // if (this.sceneList.length) {
          //   this.handleSceneClick(this.sceneList[this.sceneList.length -1 ])
          // }
          this.getSceneDocList()
        }
      })
    },
    showHideDrawer() {
      this.drawerVisible = !this.drawerVisible
    },
    dragStart(e) {
      console.log(e)
    },
    dragEnd(e) {
      console.log(e)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  .left {
    padding-left: 60px !important;

    .filter-item {
      font-size: 16px;
      font-weight: bold;
    }

    .cate-con {
      &>div {
        height: 48px;
        line-height: 48px;
        padding-left: 30px;

        &.static {
          font-weight: bold;
          font-size: 16px;

          &.scene {
            background: url('~@/assets/imgs/icon_light.png') no-repeat left center /16px auto;
          }
        }
        &.add {
          background: url('~@/assets/imgs/icon_add_circle@2x.png') no-repeat left center /16px auto;
          //cursor: no-drop;
          font-size: 14px;
        }
        &.item {
          font-size: 14px;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: flex;
          align-items: center;
          &.active {
            color: #E60027;
          }
          .name {
            margin-left: 4px;
          }
        }
      }
    }

    .filter-cus {
      font-size: 16px;
      font-weight: bold;
    }



    ::v-deep .el-menu-item {
      &:hover {
        background-color: transparent;
      }
    }
  }

  .right {
  padding: 0 20px;
    .title {
      background-color: #f5f5f5;
      padding: 10px 8px;
      font-weight: 500;
      font-size: 16px;
      display: flex;
      align-items: center;

      &>.view {
        cursor: pointer;
        margin-left: 8px;
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url('~@/assets/imgs/icon_eye.png') no-repeat center center /100% auto;
      }
    }

    .tree-con {

      // padding-left: 8px;
      ::v-deep .el-tree-node {
        margin-top: 4px;

        & .el-tree-node__label {
          color: rgba(0, 0, 0, 0.8500);
        }

        & .el-tree-node__expand-icon {
          color: rgba(0, 0, 0, 0.8500);
          font-size: 18px;
        }

        & .el-tree-node__expand-icon.is-leaf {
          color: transparent;
        }
      }

      ::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
        background-color: transparent;
      }

      &.nosub {
        &>.el-tree {
          ::v-deep &>.el-tree-node {
            &>.el-tree-node__content {
              &>.el-tree-node__expand-icon {
                display: none;
              }
            }
          }
        }
      }
    }
  }

  .drawer-con {
    position: absolute;
    right: 0;
    top: 82px;
    bottom: 0;
    background-color: #fff;
    z-index: 888;
    box-shadow: 0 0 10px #ccc;

    &>.btn-con {
      position: absolute;
      left: -40px;
      top: 50%;
      width: 40px;
      height: 160px;
      margin-top: -80px;
      text-align: center;
      cursor: pointer;

      &>.close {
        height: 160px;
        width: 40px;
        background: url('~@/assets/imgs/btn_arrow_right@2x.png') no-repeat center center / 40px auto;
      }

      &>.open {
        height: 160px;
        width: 40px;
        background: url('~@/assets/imgs/btn_arrow_left@2x.png') no-repeat center center / 40px auto;
      }
    }

    &>.list-con {
      width: 2.7rem;
      height: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      &>.title {
        flex: 0 0 auto;
        padding: 24px;
        font-size: 16px;
        font-weight: bold;
      }

      .img-con {
        flex: 1;
        padding: 0 24px;
        overflow-y: auto;
        .image-wrap {
          position: relative;
          margin-bottom: 6px;
          border: solid 1px rgba(0,0,0,.1);
          .no {
            width: 36px;
            height: 36px;
            position: absolute;
            top: 0;
            &::after {
              content: '';
              left: 0;
              top: 0;
              position: absolute;
              width: 0;
              height: 0;
              border: 18px solid #ccc;
              border-bottom-color: transparent;
              border-right-color: transparent;
              z-index: 10;
              border-radius: 4px;
            }
            .val {
              position: absolute;
              left: 5px;
              top: 0;
              color: #fff;
              z-index: 12;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
